import { Link, useLocation } from "react-router";
import logoImage from "figma:asset/ddb57671df87312087712466a3a43b048ecff0a3.png";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { JOIN_FORM_URL } from "../config/links";

export default function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  return (
    <header className="fixed top-0 w-full bg-white/90 backdrop-blur-sm border-b border-[rgba(5,14,26,0.1)] z-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center" onClick={() => setMobileMenuOpen(false)}>
          <img src={logoImage} alt="Unpatterned" className="h-8 md:h-10" />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex gap-8 items-center">
          <Link
            to="/about"
            className={`font-['Manrope',sans-serif] transition-colors ${
              location.pathname === '/about'
                ? 'text-[#050e1d] font-semibold'
                : 'text-[#050e1d]/70 hover:text-[#050e1d]'
            }`}
          >
            About
          </Link>
          <Link
            to="/labs"
            className={`font-['Manrope',sans-serif] transition-colors ${
              location.pathname === '/labs'
                ? 'text-[#050e1d] font-semibold'
                : 'text-[#050e1d]/70 hover:text-[#050e1d]'
            }`}
          >
            Labs
          </Link>
          <Link
            to="/blog"
            className={`font-['Manrope',sans-serif] transition-colors ${
              location.pathname.startsWith('/blog')
                ? 'text-[#050e1d] font-semibold'
                : 'text-[#050e1d]/70 hover:text-[#050e1d]'
            }`}
          >
            Blog
          </Link>
          <a
            href={JOIN_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#184b9d] text-white px-6 py-2.5 rounded-lg font-['Manrope',sans-serif] font-medium hover:bg-[#1e8eaf] transition-colors"
          >
            Join
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden p-2 text-[#050e1d] hover:bg-[rgba(5,14,26,0.05)] rounded-lg transition-colors"
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-b border-[rgba(5,14,26,0.1)] shadow-lg">
          <nav className="flex flex-col px-4 py-4 space-y-4">
            <Link
              to="/about"
              onClick={() => setMobileMenuOpen(false)}
              className={`font-['Manrope',sans-serif] py-2 transition-colors ${
                location.pathname === '/about'
                  ? 'text-[#050e1d] font-semibold'
                  : 'text-[#050e1d]/70'
              }`}
            >
              About
            </Link>
            <Link
              to="/labs"
              onClick={() => setMobileMenuOpen(false)}
              className={`font-['Manrope',sans-serif] py-2 transition-colors ${
                location.pathname === '/labs'
                  ? 'text-[#050e1d] font-semibold'
                  : 'text-[#050e1d]/70'
              }`}
            >
              Labs
            </Link>
            <Link
              to="/blog"
              onClick={() => setMobileMenuOpen(false)}
              className={`font-['Manrope',sans-serif] py-2 transition-colors ${
                location.pathname.startsWith('/blog')
                  ? 'text-[#050e1d] font-semibold'
                  : 'text-[#050e1d]/70'
              }`}
            >
              Blog
            </Link>
            <a
              href={JOIN_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMobileMenuOpen(false)}
              className="bg-[#184b9d] text-white px-6 py-3 rounded-lg font-['Manrope',sans-serif] font-medium hover:bg-[#1e8eaf] transition-colors text-center"
            >
              Join
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
